import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import loadCustomer from './localization/csv_convert';
import { Mki18n } from './localization/i18n';
import Structure from './routes/Structure';
import ErrorPage from './routes/common/ErrorPage';

const App = () => {
  let { mode } = useSelector((state) => state);

  const { data, error } = useQuery('localText', loadCustomer, {
    suspense: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  useEffect(() => {
    if (data) Mki18n(data, mode);
  }, [data, mode]);

  if (error) {
    return <ErrorPage error={error.code} errorInfo={error.message}></ErrorPage>;
  }

  return (
    <Router forceRefresh={false}>
      <Structure mode={mode} />
    </Router>
  );
};

export default withTranslation()(App);
